<template>
  <el-dialog title="清理库存数据" :visible.sync="show" width="560px" :close-on-click-modal="false">
    <el-alert
      title="在审批过程中的商品无法清除数据。"
      type="warning"
      :closable="false"
      show-icon
      style="margin-bottom: 18px;"
    />
    <div class="stock-name">当前商品：{{ stock.NAME }}</div>
    <el-radio-group v-model="mode" class="clear-options">
      <el-radio label="quantity" border>
        <span class="option-title">只清除产品数量</span>
        <span class="option-desc">保留当前商品、分类、单位和价格等资料，只将库存数量清零。</span>
      </el-radio>
      <el-radio label="all" border>
        <span class="option-title">清除全部数据</span>
        <span class="option-desc">删除当前商品的全部库存资料，此操作无法撤销。</span>
      </el-radio>
    </el-radio-group>
    <div slot="footer">
      <el-button @click="show = false">取消</el-button>
      <el-button type="danger" :loading="saving" @click="submit">确认清除</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      saving: false,
      mode: "quantity",
      stock: {}
    };
  },
  methods: {
    init(stock) {
      this.mode = "quantity";
      this.stock = stock || {};
      this.show = true;
    },
    submit() {
      const clearAll = this.mode === "all";
      const action = clearAll ? "删除该商品的全部库存资料" : "将该商品库存数量清零";
      this.$confirm(`即将${action}，是否继续？`, "再次确认", {
        confirmButtonText: "继续清理",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.saving = true;
        this.whale.remote.getResult({
          url: "/api/School/MAT/StockApi/ClearData",
          data: { STOCK_ID: this.stock.ID, CLEAR_ALL: clearAll },
          completed: () => {
            this.show = false;
            this.$message.success("商品库存数据清理完成");
            this.$emit("on-cleared");
          },
          finally: () => { this.saving = false; }
        });
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.clear-options {
  display: block;
}
.stock-name {
  margin-bottom: 16px;
  color: #303133;
  font-weight: 600;
}
.clear-options .el-radio {
  display: flex;
  align-items: flex-start;
  height: auto;
  margin: 0 0 12px;
  padding: 15px 18px;
  white-space: normal;
}
.option-title {
  display: block;
  color: #303133;
  font-weight: 600;
  line-height: 20px;
}
.option-desc {
  display: block;
  margin-top: 5px;
  color: #909399;
  font-size: 13px;
  line-height: 20px;
}
</style>
